import { gql } from '@apollo/client';

// 查詢我的好友列表
export const GET_MY_FRIENDS = gql`
  query GetMyFriends {
    myFriends {
      success
      message
      relationships {
        id
        userA {
          id
          username
        }
        userB {
          id
          username
        }
        typeA
        typeB
        establishedAt
        lastInteractionAt
        status
      }
      errors {
        field
        message
      }
    }
  }
`;

// 查詢待處理的好友請求
export const GET_PENDING_REQUESTS = gql`
  query GetPendingRequests {
    pendingRequests {
      success
      message
      relationships {
        id
        userA {
          id
          username
        }
        userB {
          id
          username
        }
        typeA
        typeB
        requestDirection
        matchingScore
        matchingTotalWeight
        matchingTotalScore
        matchingAnsweredQuestions
        matchingTotalQuestions
        otherUserSelfIntroduction
        establishedAt
        status
      }
      errors {
        field
        message
      }
    }
  }
`;

// 查詢我的所有關係
export const GET_MY_RELATIONSHIPS = gql`
  query GetMyRelationships {
    myRelationships {
      success
      message
      relationships {
        id
        userA {
          id
          username
        }
        userB {
          id
          username
        }
        typeA
        typeB
        establishedAt
        lastInteractionAt
        status
      }
      errors {
        field
        message
      }
    }
  }
`;

// 查詢特定關係
export const GET_RELATIONSHIP = gql`
  query GetRelationship($targetUserId: ID!) {
    relationship(targetUserId: $targetUserId) {
      success
      message
      relationship {
        id
        userA {
          id
          username
        }
        userB {
          id
          username
        }
        typeA
        typeB
        establishedAt
        lastInteractionAt
        status
      }
      errors {
        field
        message
      }
    }
  }
`;

// 發送好友請求
export const SEND_FRIEND_REQUEST = gql`
  mutation SendFriendRequest($input: CreateRelationshipInput!) {
    sendFriendRequest(input: $input) {
      success
      message
      relationship {
        id
        userA {
          id
          username
        }
        userB {
          id
          username
        }
        typeA
        typeB
        establishedAt
        status
      }
      errors {
        field
        message
      }
    }
  }
`;

// 接受好友請求
export const ACCEPT_FRIEND_REQUEST = gql`
  mutation AcceptFriendRequest($targetUserId: ID!) {
    acceptFriendRequest(targetUserId: $targetUserId) {
      success
      message
      relationship {
        id
        userA {
          id
          username
        }
        userB {
          id
          username
        }
        typeA
        typeB
        establishedAt
        status
      }
      errors {
        field
        message
      }
    }
  }
`;

// 拒絕好友請求
export const REJECT_FRIEND_REQUEST = gql`
  mutation RejectFriendRequest($targetUserId: ID!) {
    rejectFriendRequest(targetUserId: $targetUserId) {
      success
      message
      errors {
        field
        message
      }
    }
  }
`;

// 更新關係
export const UPDATE_RELATIONSHIP = gql`
  mutation UpdateRelationship($input: UpdateRelationshipInput!) {
    updateRelationship(input: $input) {
      success
      message
      relationship {
        id
        userA {
          id
          username
        }
        userB {
          id
          username
        }
        typeA
        typeB
        establishedAt
        lastInteractionAt
        status
      }
      errors {
        field
        message
      }
    }
  }
`;

// 阻止使用者
export const BLOCK_USER = gql`
  mutation BlockUser($targetUserId: ID!) {
    blockUser(targetUserId: $targetUserId) {
      success
      message
      relationship {
        id
        userA {
          id
          username
        }
        userB {
          id
          username
        }
        typeA
        typeB
        status
      }
      errors {
        field
        message
      }
    }
  }
`;

// 解除阻止
export const UNBLOCK_USER = gql`
  mutation UnblockUser($targetUserId: ID!) {
    unblockUser(targetUserId: $targetUserId) {
      success
      message
      relationship {
        id
        userA {
          id
          username
        }
        userB {
          id
          username
        }
        typeA
        typeB
        status
      }
      errors {
        field
        message
      }
    }
  }
`;

// 移除好友
export const REMOVE_FRIEND = gql`
  mutation RemoveFriend($targetUserId: ID!) {
    removeFriend(targetUserId: $targetUserId) {
      success
      message
      errors {
        field
        message
      }
    }
  }
`;

// 聊天系統相關查詢

// 獲取我的聊天室
export const GET_MY_CHATROOMS = gql`
  query GetMyChatrooms {
    myChatrooms {
      success
      message
      chatrooms {
        id
        type
        participants {
          id
          username
        }
        name
        description
        lastMessage {
          content
          senderId {
            id
            username
          }
          sentAt
        }
        unreadCounts {
          userId {
            id
          }
          count
        }
        status
        createdBy {
          id
          username
        }
        createdAt
        updatedAt
      }
      errors {
        field
        message
      }
    }
  }
`;

// 獲取聊天室詳情
export const GET_CHATROOM = gql`
  query GetChatroom($chatroomId: ID!) {
    chatroom(chatroomId: $chatroomId) {
      success
      message
      chatroom {
        id
        type
        participants {
          id
          username
        }
        name
        description
        lastMessage {
          content
          senderId {
            id
            username
          }
          sentAt
        }
        unreadCounts {
          userId {
            id
          }
          count
        }
        status
        createdBy {
          id
          username
        }
        createdAt
        updatedAt
      }
      errors {
        field
        message
      }
    }
  }
`;

// 獲取聊天室消息
export const GET_CHATROOM_MESSAGES = gql`
  query GetChatroomMessages($chatroomId: ID!, $limit: Int, $skip: Int) {
    chatroomMessages(chatroomId: $chatroomId, limit: $limit, skip: $skip) {
      success
      message
      messages {
        id
        chatroomId
        senderId {
          id
          username
        }
        content
        type
        filePath
        status
        sentAt
        readAt
        createdAt
        updatedAt
      }
      errors {
        field
        message
      }
    }
  }
`;

// 創建聊天室
export const CREATE_CHATROOM = gql`
  mutation CreateChatroom($input: CreateChatroomInput!) {
    createChatroom(input: $input) {
      success
      message
      chatroom {
        id
        type
        participants {
          id
          username
        }
        name
        description
        status
        createdBy {
          id
          username
        }
        createdAt
      }
      errors {
        field
        message
      }
    }
  }
`;

// 發送消息
export const SEND_MESSAGE = gql`
  mutation SendMessage($input: SendMessageInput!) {
    sendMessage(input: $input) {
      success
      message
      messageData {
        id
        chatroomId
        senderId {
          id
          username
        }
        content
        type
        filePath
        status
        sentAt
        readAt
        createdAt
        updatedAt
      }
      errors {
        field
        message
      }
    }
  }
`;

// 標記消息爲已讀
export const MARK_MESSAGES_AS_READ = gql`
  mutation MarkMessagesAsRead($chatroomId: ID!) {
    markMessagesAsRead(chatroomId: $chatroomId) {
      success
      message
      errors {
        field
        message
      }
    }
  }
`;

// 訂閱好友請求
export const FRIEND_REQUEST_RECEIVED = gql`
  subscription FriendRequestReceived {
    friendRequestReceived {
      id
      userA {
        id
        username
      }
      userB {
        id
        username
      }
      typeA
      typeB
      establishedAt
      status
    }
  }
`;

// 訂閱新消息
export const MESSAGE_RECEIVED = gql`
  subscription MessageReceived($chatroomId: ID!) {
    messageReceived(chatroomId: $chatroomId) {
      id
      chatroomId
      senderId {
        id
        username
      }
      content
      type
      filePath
      status
      sentAt
      readAt
      createdAt
      updatedAt
    }
  }
`; 